import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { COMPANY } from "@/lib/assets";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-white" data-testid="datenschutz-page">
      <Header />
      <main className="pt-28 md:pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#0A3B2C] hover:underline mb-8" data-testid="datenschutz-back-link">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>

          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-3">Rechtliches</div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0A3B2C] mb-10" style={{ fontFamily: "Outfit, sans-serif" }}>
            Datenschutzerklärung
          </h1>

          <div className="space-y-10 text-gray-700 leading-relaxed text-sm md:text-base">
            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">1. Datenschutz auf einen Blick</h2>
              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem
                Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Datenerfassung auf dieser Website</h3>
              <p>
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
                Kontaktdaten können Sie dem Abschnitt {"\u201eHinweis zur verantwortlichen Stelle\u201c"} in dieser
                Datenschutzerklärung entnehmen.
              </p>
              <p className="mt-3">
                <strong>Wie erfassen wir Ihre Daten?</strong><br />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z. B. Daten,
                die Sie in ein Kontaktformular eingeben). Andere Daten werden automatisch oder nach
                Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst.
              </p>
              <p className="mt-3">
                <strong>Wofür nutzen wir Ihre Daten?</strong><br />
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
                gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>
              <p className="mt-3">
                <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
                Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">2. Hosting</h2>
              <p>
                Wir hosten die Inhalte unserer Website bei einem professionellen Cloud-Hosting-Provider
                in Deutschland / der EU. Beim Aufruf unserer Website werden technische Logfiles
                inklusive Ihrer IP-Adresse durch den Hoster erfasst. Die Verwendung erfolgt auf
                Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">3. Allgemeine Hinweise und Pflichtinformationen</h2>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
                behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Hinweis zur verantwortlichen Stelle</h3>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-3">
                faktor-direkt<br />
                {COMPANY.managingDirectors}<br />
                {COMPANY.street}<br />
                {COMPANY.city}<br />
                Telefon: {COMPANY.phone}<br />
                E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#0A3B2C] underline">{COMPANY.email}</a>
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Speicherdauer</h3>
              <p>
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
                Datenverarbeitung entfällt.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Rechtsgrundlagen der Datenverarbeitung</h3>
              <p>
                Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
                personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Sind Ihre Daten
                zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich,
                verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Die
                Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach
                Art. 6 Abs. 1 lit. f DSGVO erfolgen.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Widerruf Ihrer Einwilligung</h3>
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
                möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Beschwerderecht bei der Aufsichtsbehörde</h3>
              <p>
                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei
                einer Aufsichtsbehörde zu.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">SSL- bzw. TLS-Verschlüsselung</h3>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
                Inhalte eine SSL- bzw. TLS-Verschlüsselung.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">4. Datenerfassung auf dieser Website</h2>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Server-Log-Dateien</h3>
              <p>
                Der Provider der Seiten erhebt und speichert automatisch Informationen in
                Server-Log-Dateien, die Ihr Browser übermittelt: Browsertyp, Browserversion,
                Betriebssystem, Referrer URL, Hostname, Uhrzeit und IP-Adresse.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>

              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Anfrage per E-Mail oder Telefon</h3>
              <p>
                Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
                daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres
                Anliegens bei uns gespeichert und verarbeitet.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#0A3B2C] mb-3">5. Plugins und Tools</h2>
              <h3 className="text-base font-semibold text-[#111827] mt-4 mb-2">Google Fonts</h3>
              <p>
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten sogenannte Google
                Fonts, die von Google bereitgestellt werden. Die Nutzung erfolgt auf Grundlage von
                Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen finden Sie in der{" "}
                <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#0A3B2C] underline">
                  Datenschutzerklärung von Google
                </a>.
              </p>
            </section>

            <p className="text-xs text-gray-500 pt-6 border-t border-gray-200">
              Quelle dieser Vorlage: e-recht24.de – inhaltlich angepasst.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
